module.exports = __webpack_public_path__ + "img/croc1.5a7cf819.svg";